export const ACSIDENTITY_STRINGS = {
    ADD_ACSIDENTITY: "Add ACSIdentity",
    REFRESH_ACSIDENTITY: "Refresh ACSIdentity",
};

export const ACSIDENTITY_KEYS = {
    ID: "id",
};

export const ACSIDENTITY_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "id", isSortable: true, label: "ACSIdentity ID" },
    { id: "acsidentitytoken", isSortable: true, label: "Token" },
    { id: "acsidentityexpiration", isSortable: true, label: "Expiration" },
];

export const ACSIDENTITY_TABLE_COLUMN_KEYS = {
    ID: "id",
    ACTIONS: "actions",
};

export const ACSIDENTITY_MESSAGES = {
    NO_ACSIDENTITY: "No acsidentity to display",
    ACSIDENTITY_ADDED: "ACSIdentity created successfully!",
    ACSIDENTITY_REFRESHED: "ACSIdentity refresh successfully!",
};

export const ACSIDENTITY_ERRORS = {
    FETCH_ACSIDENTITY_ERROR: "Error fetching acs identity:",
    REFRESH_ACSIDENTITY_ERROR: "Error refreshing acsidentity token",
    UPDATE_CALL_JOB_MAPPING_ERROR: "Error updating call job mapping",
    ADD_CUSTOMER_RELATED_RECORD_ERROR: "Error adding customer related record",
};

